export default __webpack_public_path__ + "static/media/5.5d84209c.jpg";